export default __webpack_public_path__ + "static/media/022-tin man.a24531b3.svg";